import {
  QuizBanner,
  useQuoteWizardAssetQuery,
  useQuoteWizardQuery
} from '@ecomm/lander'
import React from 'react'

export function QuoteWizardEmbedded() {
  const quoteWizardAsset = useQuoteWizardAssetQuery()
  const quoteWizardData = useQuoteWizardQuery('3GT1zG3PE5djEurbN7NQmm')

  return (
    <div data-component="QuoteWizardEmbedded">
      <QuizBanner
        image={quoteWizardAsset}
        quoteWizard={quoteWizardData.quoteWizard}
      />
    </div>
  )
}
